import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import successIcon from 'shared/assets/images/success.png';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SuccessBlock.css';

class SuccessBlock extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };
  render() {
    const { title } = this.props;
    const isMobile = __APP__ === 'mobile';

    return (
      <div className={cx(s.root, { [s.mobileRoot]: isMobile })}>
        <img src={successIcon} className={s.icon} alt="" />
        <div className={s.title}>
          <FormattedMessage id={title} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SuccessBlock);



// WEBPACK FOOTER //
// ./src/shared/components/SuccessBlock/SuccessBlock.js